import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft, FileText, Scissors, Paperclip, Box, Shirt, Palette } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function MasterDataNew({ user, onLogout }) {
  const navigate = useNavigate();

  const masterDataModules = [
    {
      id: 'vendors',
      title: 'Vendor Data',
      description: 'Manage vendor data',
      icon: FileText,
      path: '/master-data/vendors'
    },
    {
      id: 'fabrics',
      title: 'Fabric (LN-CODE)',
      description: 'Manage fabric data',
      icon: Scissors,
      path: '/master-data/fabrics'
    },
    {
      id: 'trims',
      title: 'Trims & Accessories (LN-Z-CODE)',
      description: 'Manage trims & accessories data',
      icon: Paperclip,
      path: '/master-data/trims'
    },
    {
      id: 'packaging',
      title: 'Packaging (LN-Y-CODE)',
      description: 'Manage packaging data',
      icon: Box,
      path: '/master-data/packaging'
    },
    {
      id: 'articles',
      title: 'Article (LN-X-CODE)',
      description: 'Generate article code',
      icon: Shirt,
      path: '/master-data/articles'
    },
    {
      id: 'digital-designs',
      title: 'Digital Design (LN-T-CODE)',
      description: 'Generate digital design code',
      icon: Palette,
      path: '/master-data/digital-designs'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <header className="bg-white shadow-md border-b mb-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <div>
              <h1 className="text-2xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Master Data Entry</h1>
              <p className="text-sm text-gray-600">Manage all master data entities</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {masterDataModules.map((module) => {
            const Icon = module.icon;
            return (
              <Card
                key={module.id}
                className="hover:shadow-xl transition-all duration-300 cursor-pointer border-2 border-black"
                onClick={() => navigate(module.path)}
                data-testid={`module-card-${module.id}`}
              >
                <CardHeader className="text-center">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 rounded-lg bg-black flex items-center justify-center">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                  </div>
                  <CardTitle className="text-xl" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    {module.title}
                  </CardTitle>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      </main>
    </div>
  );
}
